import { LegalEntityAuditFrequency, LegalEntityAuditType, LegalEntitySelectorViewModel, LegalEntityTemplateStepInfo } from "../LegalEntity.types";
import { SelectableColoredItem } from "../../processingActivity/ProcessingActivity.types.ts";
import { LegalEntityStandardField } from "../../entityTemplates/EntityTemplate.types";

export interface LegalEntityModel {
    userFriendlyId: number;
    name: string;
    description: string;
    address: string;
    city: string;
    zipCode: string;
    companyRegistrationNumber: string;
    isCustomerOwned: boolean;
    isActive: boolean;
    country: string;
    levelOfProtection: LevelOfProtectionType | null;
    note: string;
    type: string | null;
    isTIAUnnecessary: boolean;
    isTransferBasisUnnecessary: boolean;
    transferBasisId?: string;
    addDataPrivacyFrameworkToSharings: boolean;
    certifications: Array<string>;
    areas: Array<string>;
    isThirdCountry: boolean;
    website: string | null;
    responsible: string | null;
    businessAreas: Array<SelectableColoredItem>;
    types: Array<string>;
    auditType?: LegalEntityAuditType;
    auditFrequency?: LegalEntityAuditFrequency;
    isDataProcessor: boolean;
    isSubDataProcessor: boolean;
    subContractors: Array<LegalEntitySelectorViewModel>;
    tags: Array<SelectableColoredItem>;
    isPreselectedOnCreate: boolean;
    template: string | null;
    entityTemplateId: string;
    templateSteps: Array<LegalEntityTemplateStepInfo>;
    overviewTopFields: Array<LegalEntityStandardField>;
    overviewBottomFields: Array<LegalEntityStandardField>;
}

// The company details a CVR lookup fills are not held here: they are template fields rendered and validated
// against the edited legal entity, so keeping a second copy would let the two disagree.
export interface LegalEntitySaveModel {
    name: string;
    countryCode: string;
    isCustomerOwned: boolean;
    type?: string;
    entityTemplateId: string;
}

export enum LevelOfProtectionType {
    None,
    AdequateProtection,
    EU,
    PrivacyShield,
    EEA,
    ThirdCountry,
    CPIEDA,
    DataPrivacyFramework,
}
